module.exports = __webpack_public_path__ + "img/maisonette-9.b4855189.webp";